/* src/app/opportunities/pages/opportunities/opportunities.component.scss */
/*# sourceMappingURL=opportunities.component.css.map */
